const NAME_OR_ADDRESS_REGEX = /^[a-zA-Z0-9\s,'-]+$/;
const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const POSTCODE_REGEX = /^(([A-Z][0-9]{1,2})|(([A-Z][A-HJ-Y][0-9]{1,2})|(([A-Z][0-9][A-Z])|([A-Z][A-HJ-Y][0-9]?[A-Z])))) [0-9][A-Z]{2}$/;
const PHONE_REGEX = /^\d+$/;
const COUNTRY_REGEX = /^[a-zA-Z]+[ ]*/;

function _isInputValid(input, type, pattern) {
  let regex;

  switch (type) {
    case "FIRST_NAME":
    case "LAST_NAME":
    case "ADDRESS_LINE_1":
    case "ADDRESS_LINE_2":
      regex = NAME_OR_ADDRESS_REGEX;
      break;
    case "EMAIL":
      regex = EMAIL_REGEX;
      break;
    case "PHONE":
    case "MOBILE":
      regex = PHONE_REGEX;
      break;
    case "POSTCODE":
      regex = POSTCODE_REGEX;
      break;
    case "COUNTRY":
      regex = COUNTRY_REGEX;
      break;
    case "PASSWORD":
      regex = pattern;
      break;
    default:
      break;
  }

  return regex.test(input);
}

export { NAME_OR_ADDRESS_REGEX, EMAIL_REGEX, POSTCODE_REGEX, PHONE_REGEX, COUNTRY_REGEX, _isInputValid };
